import { OpaccFormElementDateTimePicker } from './opacc.class.form.element.datetimepicker.js';

/** @module form */

/**
 * Funktionalität zur Auswahl der Uhrzeit mittels "Picker"
 *
 * @extends {OpaccFormElementDateTimePicker}
 */
export class OpaccFormElementTimePicker extends OpaccFormElementDateTimePicker{
	constructor(customSettings = null) {
		super();
		this.wrapperElement = document.querySelector('.content');
		this.timePickerWrapperSelector = '.opc-time';
		this.timePickerFields = this.wrapperElement.querySelectorAll(`${this.timePickerWrapperSelector}`);

		this.initTimePicker(customSettings);
	}

	initTimePicker(customSettings) {
		Array.from(this.timePickerFields).forEach(item => {
			let inputField = item.querySelector('input[type="text"]');

			const defaultSettings = {
				enableTime: true,
				noCalendar: true,
				dateFormat: 'H.i',
				altFormat: 'H:i',
				altInput: true,
				time_24hr: true,
				minuteIncrement: 1,
				enableSeconds: false,
				appendTo: item,
				allowInput: true,
                static: true
			};

			if (customSettings) {
				if (typeof customSettings != 'object') {
					throw new Error ('inputparameter must be an Object!');
				}
			}

			let settings = Object.assign(defaultSettings, customSettings);
			this.createTimePicker(inputField, settings);
		});
	}

	/**
	 *
	 *
	 * @param {*} inputField
	 * @param {*} config
	 */
	createTimePicker(inputField ,config) {
		this.timePicker = this.createDateTimePicker(inputField, config);
		this.triggerTimePickerEvents();
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	triggerTimePickerEvents() {
		return this.triggerDateTimePickerEvents(this.timePicker);
	}
}